export default {"src":"/_next/static/media/arrow.32857c41.svg","height":7,"width":12};